import { customAxios } from "./customAxios";

/**
 * 마스터 자재 이미지 삭제
 * @param {*} param 
 */
export const deleteMasterEquipmentPartsImagesById = async(id)=>{
 await customAxios.delete('/api/masterEquipmentParts/images/'+id);
}

/**
 * 마스터 자재 이미지 목록
 * @param {*} query 
 * @returns 
 */
export const getMasterEquipmentPartsImagesByQuery = async(query)=>{
  const res = await customAxios.get('/api/masterEquipmentParts/images', {params : query});
  if (res.data) {
     return res.data;
  }
  return null;
}

/**
 * 마스터 자재 이미지 상세
 * @param {*} id 
 * @returns 
 */
export const getMasterEquipmentPartsImagesById = async(id)=>{
  const res = await customAxios.get('/api/masterEquipmentParts/images/'+id);
  if (res.data) {
    return res.data;
  }
  return null;
}

/**
 * 설비상세의 부품이미지 목록
 * @param {*} query 
 * @returns 
 */
export const getEquipmentPartsIncludingFaultsByEquipmentId = async(id)=>{
  const res = await customAxios.get('/api/equipmentParts/equipments/'+id+':includingFaults');
  if (res.data) {
     return res.data;
  }
  return null;
}